import React from 'react'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'
import {
  StyledContainer,
  StyledContentContainer,
  StyledHeaderContainer,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledIconContainer,
  StyledContent,
  StyledActionContainer,
  StyledMetadataContainer
} from './index.css'

type VocSoundbiteFrameProps = {
  dateItem: React.ReactNode
  domainIcon: React.ReactElement
  headerInfo: React.ReactElement
  internalContents: React.ReactNode
  actionItems: React.ReactNode
  metadataItems: React.ReactNode
  mediaItems: React.ReactNode
  avatar: React.ReactNode
  serialNumber: number
  onClick?: (content: any) => void
}

const VocSoundbiteFrame = ({
  headerInfo,
  dateItem,
  domainIcon,
  internalContents,
  actionItems,
  metadataItems,
  mediaItems,
  avatar,
  serialNumber,
  onClick
}: VocSoundbiteFrameProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledContainer
      mode={theme}
      data-testid={`${AutomationId.soundbiteDefaultFrame.post}-${serialNumber}`}>
      {avatar}
      <StyledContentContainer onClick={onClick}>
        <StyledHeaderContainer>
          <StyledHeaderLeft>{headerInfo}</StyledHeaderLeft>
          <StyledHeaderRight mode={theme}>
            {dateItem}
            <StyledIconContainer>{domainIcon}</StyledIconContainer>
          </StyledHeaderRight>
        </StyledHeaderContainer>
        <StyledContent mode={theme}>{internalContents}</StyledContent>
        {actionItems && <StyledActionContainer>{actionItems}</StyledActionContainer>}
        {mediaItems}
        <StyledMetadataContainer mode={theme}>{metadataItems}</StyledMetadataContainer>
      </StyledContentContainer>
    </StyledContainer>
  )
}

export default VocSoundbiteFrame
